import { faChevronDown, faChevronUp, faCoins } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, useContext } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { ArrowDown, CardHeaderStyled, EditButton, RowStyled } from './style';

const FinancialItem: FC<any> = ({ children, eventKey, onEditCallback }) => {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionToggle(eventKey);

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <Accordion.Toggle
      as={CardHeaderStyled}
      eventKey={eventKey}
      onClick={decoratedOnClick}
    >
      <RowStyled>
        <FontAwesomeIcon icon={faCoins} size="2x" color="#7A8799" />
        {children}
        {!isCurrentEventKey && (
          <ArrowDown icon={faChevronDown} size="2x" color="#7A8799" />
        )}
        {isCurrentEventKey && (
          <ArrowDown icon={faChevronUp} size="2x" color="#7A8799" />
        )}
        {/* Desabilitado na tarefa PP23G-724 
        {isCurrentEventKey && (
          <EditButton onClick={() => onEditCallback()}>
            Editar Conta
          </EditButton>
        )}
        Desabilitado na tarefa PP23G-724 */}
      </RowStyled>
    </Accordion.Toggle>
  );
}

export default FinancialItem;